import {PayloadAction} from '@reduxjs/toolkit';
import {excerptLength} from '../../app/reducers';
import {SearchEngine} from '../../app/search-engine/search-engine';
import {setExcerptLength} from './excerpt-length-actions';

/**
 * The excerpt length action creators.
 */
export interface ExcerptLengthActionCreators {
  /**
   * Set the length (in number of characters) of the excerpts generated by the indexer based on the keywords present in the query.
   * The index includes the top most interesting sentences (in the order they appear in the item) that fit in the specified number of characters.
   *
   * @param length - The length of the excerpt
   * @returns A dispatchable action.
   */
  setExcerptLength(length: number): PayloadAction<number>;
}

/**
 * Loads the `excerpt length` reducer and returns possible action creators.
 *
 * @param engine - The headless engine.
 * @returns An object holding the action creators.
 */
export function loadExcerptLengthActions(
  engine: SearchEngine
): ExcerptLengthActionCreators {
  engine.addReducers({excerptLength});

  return {
    setExcerptLength,
  };
}
